import type { IHeatmapFilterComponentType } from '~/modules/heatmap/types';
import type { GSelectOption } from '~/presentation/common';

import { EHeatmapFilterType, EReferralSourceOperator } from '~/modules/heatmap/types';
import { useHeatmapFilterContext, useHeatmapFilterConfig } from '~/modules/heatmap';
import { GSelectWithAutocomplete } from '~/presentation/common';
import { GCardFilter } from '~/presentation/ui';
import { useTranslation } from 'react-i18next';

// Operator options for dropdown
const REFERRAL_SOURCE_OPERATOR_OPTIONS: GSelectOption[] = [
  {
    label: 'Is exactly',
    value: EReferralSourceOperator.IS_EXACTLY,
  },
  {
    label: 'Contains',
    value: EReferralSourceOperator.CONTAINS,
  },
];

// Mock referral source URLs - TODO: Replace with actual data from API
const MOCK_REFERRAL_SOURCES = [
  'https://google.com/ads',
  'https://magazine.com/blog/123',
  'https://magazine.com/blog/how-to-get-a-lift-with-gem-x',
  'https://magazine.com/blog/xyz',
  'https://x.com/search',
  'https://facebook.com/ads',
  'https://instagram.com/story',
];

export const FilterReferralSource: IHeatmapFilterComponentType<
  EHeatmapFilterType.REFERRAL_SOURCE
> = ({ data }) => {
  const setDraftFilter = useHeatmapFilterContext((s) => s.setDraftFilter);
  const removeFilter = useHeatmapFilterContext((s) => s.removeFilter);

  const { t } = useTranslation();
  const { configInfoBy } = useHeatmapFilterConfig();

  const currentOperator = data.operator ?? EReferralSourceOperator.IS_EXACTLY;
  const currentValue = data.value ?? '';
  const configInfo = configInfoBy(EHeatmapFilterType.REFERRAL_SOURCE);

  const handleValueChange = (operator: string, value: string) => {
    setDraftFilter(EHeatmapFilterType.REFERRAL_SOURCE, {
      operator: operator as EReferralSourceOperator,
      value,
    });
  };

  return (
    <GCardFilter
      title={configInfo.label}
      icon={configInfo.icon}
      onRemove={() => removeFilter(EHeatmapFilterType.REFERRAL_SOURCE)}
    >
      <GSelectWithAutocomplete
        operatorOptions={REFERRAL_SOURCE_OPERATOR_OPTIONS}
        suggestions={MOCK_REFERRAL_SOURCES}
        selectedOperator={currentOperator}
        value={currentValue}
        placeholder={t('Input source')}
        width="432px"
        onValueChange={handleValueChange}
      />
    </GCardFilter>
  );
};
